// ============================================================================
// ENGLISH TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
  title: "Unity That Produces Peace",
  author: "By Emmanuel",
  subtitle: "Each religion has its reasons, our borders come from the past",
  description: "Module for reflection on spiritual unity and peace between traditions",
  
  nav: {
    intro: "Intro",
    religions: "Religions",
    common: "Common Ground",
    humility: "Humility"
  },

  intro: {
    emmanuelSays: "Emmanuel says:",
    ourBordersFromPast: "Our borders come from the past",
    bordersDescription: "Each religion has its reasons. Our divisions are not divine will, but the fruit of history, geography, culture.",
    divisionWork: "Division, isolation through barriers and borders of fear, is the work of our perilous past.",
    sharedHumanity: "We were born into different traditions, but we share the same humanity.",
    
    revelationTitle: "A revelation that opens eyes",
    surprisedLearning: "I was surprised one day to learn that Jews are also children of God.",
    angelMichael: "That the angel Michael is a great messenger for Muslims.",
    jesusNames: "That Jesus, Isa, Yeshua are known in various ways, even within the Christian faith.",
    diverseTribes: "Because there are diverse tribes, diverse churches, diverse families.",
    sameRealities: "We speak of the same realities with different names. This should bring us closer, not divide us.",
    
    respectTitle: "Respect: foundation of humility, guardian of peace",
    respectFoundation: "Even if brotherhood is not objectively applicable, respect is the foundation of humility, guardian of peace.",
    understandingProcess: "Understanding and respecting other religions is a process of humility. It doesn't mean renouncing one's faith, but accepting that others also seek truth.",
    
    whatBindsUs: "What truly binds us",
    seekingRelation: "Every religion seeks relationship. Every person seeks peace.",
    loveOfGod: "This relationship that binds us all is the love of God.",
    universalLink: "Love is the universal bond that transcends all borders, all languages, all traditions.",
    
    inclusionTitle: "Inclusion: even vaster than religious diversity",
    vastInclusion: "Religious diversity is vast, but even vaster is the inclusion of others where they are called by God.",
    respectDifferences: "Respecting differences of color and gender, inclusion makes us unique humans, loved by God.",
    jesusCommand: "Jesus said: 'Love one another.'",
    
    communitySpirit: "Breaking with the communitarian spirit",
    communityTerror: "Communitarianism is the terror of disguised hatred of evil. It transforms faith into tribal identity, into a wall that separates, into a weapon that wounds.",
    pridePolitics: "Our partisan spirits push us toward the politics of pride:",
    prideQuotes: "I'm right to hurt you. I'm right, period. I'm right to wage just war.",
    watchHeart: "Beware of the heart of the problem, the root of our own evil.",
    refuseDivision: "Let us refuse this drift that divides humanity in God's name.",
    
    freedomTitle: "To be free, make others free",
    freedomOthers: "To be free, we must know how to make others free too.",
    defendFreedom: "My freedom to believe only has value if I defend everyone's. Oppressing others is condemning myself to servitude.",
    
    changeHeartTitle: "Change your heart: be a true lantern",
    recognizeDecency: "Recognize that decency is not the same for everyone.",
    changeYourself: "Change yourself first, gradually. Change your heart, transform your life, be a true lantern.",
    beExample: "Don't pee on the lawn, it will perish... Don't impose your rules on others, but become a living example through your transformation.",
    
    childrenPeaceTitle: "Our children will live in peace in diversity",
    avoidPursuit: "Avoid the pursuit of words for words.",
    peaceChoice: "If we choose respect today, our future children will live in peace in diversity. Peace begins with us, now, in our words and actions.",
    
    discernTitle: "Discern: man or God?",
    manSpeaks: "Too often, it's the human heart that speaks and divides.",
    seeFruits: "We see it by the fruit of words: theft, destruction, wars. Beware of manipulating words to serve one's own pride.",
    
    lookPeaceTitle: "Look to peace and love",
    lookPeaceAll: "Look to peace for all, look to God's love for others.",
    godSpeaks: "When words produce peace, reconciliation, unity: it's God speaking. When they produce division, hatred, war: it's human pride.",
    
    watchWordsTitle: "Watch our words",
    watchShares: "Watch our sharing, watch our harmful contrary words toward others.",
    disqualify: "These evils disqualify us. The fruits of our words reveal who speaks in us: God or our own pride?",
    
    wisdomMaturityTitle: "Wisdom and maturity facing our nature",
    useScriptures: "Using scriptures (laws) to do harm is our habit, an almost natural and mischievous process.",
    hateSin: "Facing our sinful nature, we abhor evil and people who do evil.",
    separateActs: "But with wisdom and maturity, we must separate the acts from our human poverty.",
    compassionNature: "Recognize our animal nature that needs compassion and grace, while protecting ourselves according to contexts.",
    
    denounceLeadersTitle: "Denounce corrupt spiritual leaders",
    watchLeaders: "Beware of spiritual leaders or directors who seek to keep their drift and dishonesty secret.",
    noJustice: "Without justice, no example. Without knowledge, other victims perish by our silence.",
    silenceComplicity: "Silence in the face of injustice is complicity. Truth must be told to protect others."
  },

  religions: {
    title: "Diverse Religions, One Humanity",
    intro: "Christians, Muslims, Jews, Hindus, Buddhists... and many others: all seek truth",
    theirGod: "Their God:",
    theGood: "The Good:",
    theEvil: "The Evil:",
    theAngels: "The Angels:",
    theUnity: "The Unity:",
    values: "Values:",
    commonGoal: "Common Goal",
    seekingPeace: "All religions share a common goal: seeking peace, promoting love, and building a better world. Beyond our differences, we are all united in this quest for wisdom and harmony.",
    
    christianity: {
      name: "Christianity",
      godText: "One unique God, Creator Father",
      goodText: "Love of neighbor, forgiveness, peace",
      evilText: "Hatred, selfishness, violence",
      angelsText: "God's messengers (Gabriel, Michael...)",
      unityText: "One God for all people",
      values: "Love,Forgiveness,Peace,Humility,Justice"
    },
    islam: {
      name: "Islam",
      godText: "Allah, the One and Merciful",
      goodText: "Justice, charity, peace",
      evilText: "Oppression, lies, division",
      angelsText: "Angels of light (Jibril, Mikail...)",
      unityText: "There is no god but Allah",
      values: "Peace,Justice,Charity,Respect,Mercy"
    },
    judaism: {
      name: "Judaism",
      godText: "YHWH, the unique Eternal",
      goodText: "Justice, compassion, life",
      evilText: "Oppression, slander, hatred",
      angelsText: "Celestial messengers (Malakhim)",
      unityText: "Hear O Israel, the Eternal is One",
      values: "Justice,Life,Memory,Peace,Study"
    },
    hinduism: {
      name: "Hinduism",
      godText: "Brahman, the supreme reality",
      goodText: "Non-violence (ahimsa), right duty",
      evilText: "Violence, spiritual ignorance",
      angelsText: "The Devas, benevolent celestial beings",
      unityText: "All is One in Brahman",
      values: "Non-violence,Truth,Compassion,Purity,Harmony"
    },
    buddhism: {
      name: "Buddhism",
      godText: "No creator god, but respect for the sacred",
      goodText: "Compassion, wisdom, peace",
      evilText: "Suffering caused by ignorance",
      angelsText: "The Bodhisattvas, enlightened beings",
      unityText: "Buddha nature in everyone",
      values: "Compassion,Wisdom,Peace,Non-violence,Awakening"
    }
  },

  common: {
    title: "Common Ground",
    intro: "Good, Evil, Angels, One God, Relationship, Inclusion: what unites humanity",
    
    goodTitle: "The Good",
    goodDescription: "All religions teach love, justice and compassion",
    goodExamples: "Love your neighbor as yourself|Do good without distinction|Protect the weak and oppressed|Speak truth with kindness|Share what you have",
    
    evilTitle: "The Evil",
    evilDescription: "All condemn violence, lies and oppression",
    evilExamples: "Kill without justice|Steal and exploit|Lie and slander|Despise and humiliate|Divide and hate",
    
    angelsTitle: "Angels and Spiritual Beings",
    angelsDescription: "Almost all recognize benevolent celestial messengers",
    angelsExamples: "Angel messengers of God|Spiritual guides|Beings of light|Celestial protectors|Bodhisattvas and Devas",
    
    godTitle: "One God (or Supreme Reality)",
    godDescription: "Most believe in one source, a creator or ultimate reality",
    godExamples: "Christianity, Islam, Judaism: One God|Hinduism: Brahman, the supreme One|Buddhism: Universal Buddha nature|All seek ultimate truth|All aspire to unity and peace",
    
    relationTitle: "Relationship and Peace",
    relationDescription: "What truly unites all religions and all people",
    relationExamples: "Each religion seeks relationship with the divine|Each person seeks peace|This relationship that binds us all is God's love|Love is the universal bond|Peace is our common aspiration",
    
    inclusionTitle: "Inclusion: Loved by God",
    inclusionDescription: "Religious diversity is vast, but inclusion is even vaster",
    inclusionExamples: "Inclusion of others where they are called by God|Respect for differences of color|Respect for differences of gender|Inclusion makes us unique humans, loved by God|Jesus said: 'Love one another'",
    
    finalQuote: "I was surprised one day to learn that Jews are also children of God, that the angel Michael is a great messenger for Muslims, that Jesus, Isa, Yeshua are known in various ways even within the Christian faith. Because there are diverse tribes, diverse churches, diverse families.",
    finalQuote2: "We speak of the same realities with different names.",
    quoteAuthor: "Emmanuel, Unity That Produces Peace"
  },

  humility: {
    title: "7 Steps Toward Humility and Peace",
    intro: "The process to overcome communitarianism and become a true lantern",
    
    step: "Step",
    action: "Action:",
    
    step1Title: "Recognize: our borders come from the past",
    step1Description: "Division, isolation through barriers and borders of fear, is the work of our perilous past. Our divisions are not God's will.",
    step1Action: "Accept that my tradition is mine alone, and I am part of the diversity willed by God",
    
    step2Title: "Respect: foundation of humility, guardian of peace",
    step2Description: "Even if brotherhood is not objectively applicable, respect is the foundation.",
    step2Action: "Respect all beliefs, even without understanding everything",
    
    step3Title: "Understand without judging",
    step3Description: "Today, understanding others is a necessary process of humility.",
    step3Action: "Truly listen to what others believe, without judgment",
    
    step4Title: "Change yourself first: be a true lantern",
    step4Description: "Recognize that decency is not the same for everyone. Change your heart gradually, transform your life, become a true light.",
    step4Action: "Don't impose my rules on others, but be a living example through my transformation",
    
    step5Title: "Break with the communitarian spirit",
    step5Description: "Our partisan spirits push us toward the politics of pride: 'I'm right to hurt you, I'm right period.' Beware of the heart of the problem, the root of our own evil.",
    step5Action: "Refuse divisive discourse in my own community",
    
    step6Title: "To be free, make others free",
    step6Description: "My freedom depends on what I grant to others.",
    step6Action: "Defend freedom of conscience for all, not just mine",
    
    step7Title: "Avoid the pursuit of words for words",
    step7Description: "Don't respond to hatred with hatred, to insults with insults.",
    step7Action: "Choose peace so our children live in peace in diversity",
    
    discernFruits: "Discern by the Fruits",
    humanHeart: "The human heart that divides",
    lookGodLove: "Look to God's love",
    watchOurWords: "Watch Our Words",
    
    prideFruits: "Fruits of Human Pride",
    prideFruitsList: "Partisan spirit: \"I'm right, period\"|Politics of pride: \"I'm right to hurt you\"|Using scriptures to hurt (mischievous process)|Hating persons (not just acts)|Spiritual leaders hiding their drift and dishonesty|Complicit silence in the face of injustice|Division and wars|Hatred disguised as piety|Theft and destruction|Manipulation for pride|Contempt and violence",
    
    godFruits: "Fruits of God's Love",
    godFruitsList: "Separating acts from person with wisdom|Compassion for our human poverty|Grace while protecting ourselves according to contexts|Denouncing injustice to protect others|Speaking truth with courage|Peace for all|Love without distinction|Reconciliation and unity|Humility and respect|Freedom for all",
    
    finalQuote: "Even if brotherhood is not objectively applicable, respect is the foundation of humility, guardian of peace. Avoid the pursuit of words for words, and our children of the future will live in peace in diversity.",
    author: "Emmanuel"
  },

  footer: {
    quote: "Respect is the foundation of humility, guardian of peace. Our children will live in peace in diversity if we choose respect today.",
    author: "Emmanuel, Unity That Produces Peace"
  }
};

export default unityTranslations;
